module.exports = __webpack_public_path__ + "img/btn-right.930e9bd3.png";